export enum VinImageIds {
  VIN_FRONT = 'vin-front',
  VIN_SIDE = 'vin-side',
  VIN_ETCHING_FRONT = 'vin-etching-front',
  VIN_ETCHING_SIDE = 'vin-etching-side',
  ELANTRA_FRONT = 'elantra-front',
  ELANTRA_DRIVER_SIDE_DOOR = 'elantra-driver-side-door',
}
